import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatPaginator, PageEvent, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { HeadquarterService } from 'src/app/services/headquarter/headquarter.service';
import { RoleService } from 'src/app/services/role/role.service';
import { SensorReadingplaceService } from 'src/app/services/sensor-readingplace/sensor-readingplace.service';
import { SensorTypeService } from 'src/app/services/sensor-type/sensor-type.service';
import { MessageModalComponent } from 'src/app/shared/components/modals/message/message-modal.component';
import { RoleModalComponent } from 'src/app/shared/components/modals/role/role-modal.component';
import { SensorReadingplaceModalComponent } from 'src/app/shared/components/modals/sensor-readingplace-modal/sensor-readingplace-modal.component';
import { DeviationModalComponent } from 'src/app/shared/components/modals/sensor-type-modal/deviation-modal/deviation-modal.component';
import { GraphAssignModalComponent } from 'src/app/shared/components/modals/sensor-type-modal/graph-assign-modal/graph-assign-modal.component';
import { SensorTypeModalComponent } from 'src/app/shared/components/modals/sensor-type-modal/sensor-type-modal.component';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { AlertService, MessageSeverity } from 'src/app/shared/services/alert.service';
import { EmitterService } from 'src/app/shared/services/emitter.service';

@Component({
  selector: 'app-sensor-type',
  templateUrl: './sensor-type.component.html',
  styleUrls: ['./sensor-type.component.css']
})
export class SensorTypeComponent implements OnInit {

  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['name','action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isAdminGys: boolean = false;
  countMaxUserByEnterprise: number = 0;
  enterprises = [];
  headquarters = [];
  subscription: Subscription;
  enterpriseSelect: number = 0;
  headquarterSelect: number = 0;
  pageEvent: PageEvent;
  pageIndex: number = 0;
  pageSize: number = AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION;
  length: number = 0;
  page: number = 1;
  color1: string;
  color2: string;
  colorFont: string;
  colorFont2: string;
  searchText: string = '';
  timer:any;
	timeoutVal = 800;
  enabledRead: number;
  enabledWrite: number;

  constructor(
    public dialog: MatDialog,
    private alertService: AlertService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private emitterService: EmitterService,
    private sensorTypeService: SensorTypeService,
    ) {
      document.getElementById("titleHeaderNav").innerHTML = 'Administración > <span class="font-weight-bold">Tipo de Sensores</span>';
     }

  ngOnInit() {
    this.setLS();
    this.isAdminGys = (+localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.AdministradorGyS || +localStorage.getItem(AppConstants.Session.ROLID) == AppConstants.UserRole.UsuarioGyS) ? true : false;
    this.dataSource.paginator = this.paginator;
    this.paginator._intl.itemsPerPageLabel = '';
    this.getList();

    this.subscription = this.emitterService.getMessage().subscribe(message => {
      if (message == AppConstants.EmitterService.ListUsers) {
        this.getList();
      }
      if (message == AppConstants.EmitterService.ListUsersEdit) {
        this.getList();
      }
    });
  }

  setLS(){
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.colorFont = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT);
    this.colorFont2 = localStorage.getItem(AppConstants.Session.THEME_COLOR_FONT2);
    //validate Permisses menu
    var menu = JSON.parse(localStorage.getItem(AppConstants.Session.MENU));
    var page = this.router.url.split("/");
    var i = page[page.length-1];
    var itemTag = menu.filter(x => x.tag != null && (x.tag.toString()).toLowerCase().includes(i));
    if(itemTag.length>0){
      this.enabledRead = itemTag[0].activeRead;
      this.enabledWrite = itemTag[0].activeWrite;
    }else{
      this.enabledRead = 0;
      this.enabledWrite = 0;
    }
  }

  getList(){
    var filter = {
      Page: this.page,
      Rows: AppConstants.Paginado.DEFAULT_PAGE_SIZE_PAGINATION,
      Filter: this.searchText
    };
    this.spinner.show();
    this.sensorTypeService.getList(filter).subscribe((_) => {
      if(_.error == null){
        this.dataSource = new MatTableDataSource(_["rows"]);
        this.pageIndex = +_["page"]-1;
        this.length = _["total"];
      }
      this.spinner.hide();
    });
  }

  getServerData(event?: PageEvent) {
    this.page = event.pageIndex + 1;
    this.getList();
  }

  openAddModal() {
    let dialogRef = this.dialog.open(SensorTypeModalComponent, {
      data: {
        title: AppConstants.TitleModal.CREATE_SENSOR_TYPE,
        action: AppConstants.OperationType.ADD,
        isAdminGys: this.isAdminGys ,
        color: this.color1,
        colorFont: this.color2,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        obj:null},
      width: '500px',
      hasBackdrop: true
    });
    dialogRef.afterClosed().subscribe(_ => {
      if (_.result == true) {
        this.page = 1;
        this.paginator.pageIndex = 0;
        this.getList();
      }
    });
  }

  openGraphModal(data){
    let dialogRef = this.dialog.open(GraphAssignModalComponent, {
      data: {
        title: AppConstants.TitleModal.LIST_SENSOR_TYPE_ASSIGN + data.name,
        action: AppConstants.OperationType.UPDATE,
        idSensorType: data.id,
        color: this.color1,
        colorFont: this.color2,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        obj:data},
      width: '500px',
      hasBackdrop: true
    });
  }

   openDeviationModal(data){
    let dialogRef = this.dialog.open(DeviationModalComponent, {
      data: {
        title: AppConstants.TitleModal.LIST_SENSOR_TYPE_DERIVATION + data.name,
        sensorType: data.name,
        action: AppConstants.OperationType.UPDATE,
        idSensorType: data.id,
        color: this.color1,
        colorFont: this.color2,
        enabledWrite: this.enabledWrite,
        enabledRead: this.enabledRead,
        obj:data},
      width: '700px',
      hasBackdrop: true
    });
  }

  openEditModal(data){
      let dialogRef = this.dialog.open(SensorTypeModalComponent, {
        data: {
          title: AppConstants.TitleModal.UPDATE_SENSOR_TYPE,
          action: AppConstants.OperationType.UPDATE,
          isAdminGys: this.isAdminGys,
          color: this.color1,
          colorFont: this.color2,
          enabledWrite: this.enabledWrite,
          enabledRead: this.enabledRead,
          obj:data},
        width: '500px',
        hasBackdrop: true
      });
      dialogRef.afterClosed().subscribe(_ => {
        if (_.result == true) {
          this.getList();
        }
      });
  }

  delete(obj) {
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
        title: AppConstants.TitleModal.DELETE_CONFIRMATION_TITLE,
        message: `${AppConstants.MessageModal.DELETE_DEFAULT}`,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR'
        }
      },
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(response => {
      if (response.result == true) {
        this.deleteSecurity(obj.id);
      }
    });

  }

    deleteSecurity(id: number) {
      this.spinner.show();
      var data = {
        id: id,
        idUser: localStorage.getItem(AppConstants.Session.USERID)
      }
      this.sensorTypeService.delete(data).subscribe((response => {
        this.spinner.hide();
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_ROLE, AppConstants.MessageModal.DELETE, MessageSeverity.success);
        this.getList();
      }),
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(AppConstants.TitleModal.DELETE_ROLE, error.error.messages, MessageSeverity.error);
        this.spinner.hide();
      });
    }

    applyUpFilter(event: Event) {
      const filterValue = (event.target as HTMLInputElement).value;
      this.searchText = filterValue.trim().toLowerCase();
        var _this = this;
        window.clearTimeout(_this.timer);
          _this.timer = window.setTimeout(() => {
              _this.page = 1;
              _this.paginator.pageIndex = 0;
              _this.getList();
            }, _this.timeoutVal);
    }

    applyPressFilter(event: Event) {
      var _this = this;
      window.clearTimeout(_this.timer);
    }
}
